import { render, staticRenderFns } from "./xeDiscomfortIndex.vue?vue&type=template&id=128c38c2&scoped=true"
import script from "./xeDiscomfortIndex.vue?vue&type=script&lang=js"
export * from "./xeDiscomfortIndex.vue?vue&type=script&lang=js"
import style0 from "./xeDiscomfortIndex.vue?vue&type=style&index=0&id=128c38c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128c38c2",
  null
  
)

export default component.exports